import React from 'react';
import { gallery } from '../data/site';
export function Gallery() {
  return <section aria-labelledby="gallery-title" className="w-full bg-white" data-id="element-174" data-mp="34cqaf85zf3tm">
      <div className="gutter pb-8 pt-16 md:pt-24" data-id="element-175" data-mp="34ej6jtiyy5nd">
        <h2 id="gallery-title" className="display text-[clamp(2.5rem,5vw,5.5rem)] font-extrabold text-navy" data-id="element-176" data-mp="3ib6gcww0sqap">
          On the Water
        </h2>
      </div>
      <ul className="grid grid-cols-2 gap-1 md:grid-cols-3" data-id="element-177" data-mp="3dbbreyvt2asa">
        {gallery.map((g, i) => <li key={g.src} className={`group overflow-hidden ${i === 0 ? 'col-span-2 row-span-2 aspect-square md:aspect-auto' : i === gallery.length - 1 ? 'col-span-2 aspect-[2/1] md:col-span-1 md:aspect-square' : 'aspect-square'}`} data-id="element-178" data-mp="2pl7l2jr8fwxl" data-mpi={i}>
            <img src={g.src} alt={g.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-105" data-id="element-179" data-mp="26vhsm3axzn8u" />
          </li>)}
      </ul>
    </section>;
}